<router-outlet></router-outlet>
<app-lazy-loading></app-lazy-loading>
